import React, { useRef, useState } from "react";
import { Dimmer } from "./spinner";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import axios from "axios";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  validaNumeroTelefono,
  validaEmail,
  diasMes,
  cmes,
  seleccionarCampo,
} from "../util/varios";
import { Mensaje, MensajeSiNo } from "./mensajes";
import CatalogoAgenteTipo2 from "../catalogos/catalogoAgenteTipo2";

export const ProduccionxClasificador = (props) => {
  const op = require("../../public/modulos/datos");
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const anioActu = JSON.parse(localStorage.getItem("anioactu"));
  const token = JSON.parse(localStorage.getItem("token"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const cmbClase = useRef();
  const cmbActivo = useRef();
  const radioPeriodo = useRef();
  const radioAnual = useRef();

  const radioTodos = useRef();
  const radioUno = useRef();

  const txtAgente = useRef();

  const [teclas, setTeclas] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [anio, setAnio] = useState([]);
  const [records, setRecords] = useState([]);
  const [catalogo, setCatalogo] = useState(false);
  const [visible, setVisible] = useState({
    periodo: "visible",
    anual: "visible",
  });

  const [agente, setAgente] = useState({
    idagente: "",
    nombre: "",
    rif: "",
    direccion: "",
  });

  const [visibleTodos, setVisibleTodos] = useState(false);

  const onChange = (event) => {
    if (event.target.name === "rango") {
      if (event.target.value === "1") {
        setVisible({
          ...visible,
          periodo: "visible",
          anual: "visible",
        });
      }

      if (event.target.value === "2") {
        setVisible({
          ...visible,
          periodo: "collapse",
          anual: "visible",
        });
      }
    }
  };

  const blanquear = () => {
    setActivate(false);
    setVisible({
      periodo: "visible",
      anual: "visible",
    });
    setVisibleTodos(false);
    setAgente({
      idagente: "",
      nombre: "",
      rif: "",
      direccion: "",
    });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  const cerrarModal = () => {
    if (mensaje.titulo === "Exito.") {
      props.onHideRenderizar();
      props.onHideCancela();
      blanquear();
    }

    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const imprimirReporte = () => {
    let condicion = "";
    let tipo = "";
    let subtitulo = "";
    let sigue = false;

    if (cmbActivo.current.value === "0") {
      tipo = records[cmbClase.current.selectedIndex].descripcion;
      subtitulo = "Todos Los Productores";
      condicion = `cx.idclaseproduccion=${cmbClase.current.value}`;
      sigue = true;
    }

    if (cmbActivo.current.value === "51") {
      tipo = records[cmbClase.current.selectedIndex].descripcion;
      subtitulo = "Productores Activos";
      condicion = `cx.idclaseproduccion=${cmbClase.current.value} and ag.statusproduccion=${cmbActivo.current.value}`;
      sigue = true;
    }

    if (cmbActivo.current.value === "52") {
      tipo = records[cmbClase.current.selectedIndex].descripcion;
      subtitulo = "Productores Inactivos";
      condicion = `cx.idclaseproduccion=${cmbClase.current.value} and ag.statusproduccion=${cmbActivo.current.value}`;
      sigue = true;
    }

    if (sigue) {
      window.open(
        `${op.reportes}reporte=ListadoAgenteClaseProduccion&CONDICION=${condicion}&TIPO=${tipo}&SUBTITULO=${subtitulo}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    }
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "claseproduccion";
    let orden = "idclaseproduccion";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          } else {
            setRecords([]);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarRegistros();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <Modal.Title style={{ color: "#fff" }}>
          Contribuyentes por Rubro
        </Modal.Title>
        <button
          ref={btnCancela}
          style={{
            border: 0,
            margin: 0,
            padding: 0,
            color: "#ffffff",
            backgroundColor: "transparent",
          }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <div>
          <div style={{ fontFamily: "Times New Roman, Times, serif" }}>
            <fieldset className=" row col-sm-12 mx-auto border rounded ">
              <legend
                className="float-none w-auto"
                style={{ fontSize: "15px", fontWeight: "bold" }}
              >
                Clasificador Produccion:
              </legend>

              <div className="row col-md-12 justify-content-between">
                <select
                  ref={cmbActivo}
                  className="form-select form-select-sm col-md-4"
                >
                  <option key="01" value="0">
                    TODOS
                  </option>
                  <option key="02" value="51">
                    ACTIVOS
                  </option>
                  <option key="03" value="52">
                    INACTIVOS
                  </option>
                </select>

                <select
                  name="clase"
                  ref={cmbClase}
                  onChange={onChange}
                  className="form-select form-select-sm col-md-6"
                >
                  {records &&
                    records.map((a, i) => (
                      <option key={i} value={a.idclaseproduccion}>
                        {a.descripcion}
                      </option>
                    ))}
                </select>
              </div>
            </fieldset>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          onClick={imprimirReporte}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <Mensaje mensaje={mensaje} onHide={cerrarModal} />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/modalProduccionxClasificador.js